import { Ref } from "react";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { validateInitialDetailsFieldValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import { useMediaById } from "@coworker/app/src/components/RoomSettings/hooks/useMediaById";
import TitledTextWithModal from "@coworker/apprestructured/src/task-management/components/TitledTextWithModal/TitledTextWithModal";
import { MediaTypes } from "@coworker/app/src/components/RoomSettings/constants";
import { MediaPlacementsListView } from "@coworker/apprestructured/src/media-maintenance/components/MediaPlacementSection/MediaPlacementsModal/MediaPlacementsListView";
import { MediasAndArticleCountResponse } from "@coworker/app/src/components/RoomSettings/types/media";

export type MediaLocationCreatorFragmentConfigProps = {
  field: string;
  title: string;
};

type MediaLocationCreatorFragmentProps = {
  configProps: MediaLocationCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function MediaLocationCreatorFragment({
  configProps,
  commonProps,
}: MediaLocationCreatorFragmentProps) {
  const { field, title } = configProps;
  const { task, taskType } = commonProps;
  const mediaId = validateInitialDetailsFieldValue<string>(
    getByPath(task, field),
    field,
    taskType
  );
  const { data: mediaResponse, isLoading: isMediaLoading } = useMediaById(
    isLoading(mediaId) ? null : mediaId
  );

  const media = mediaResponse?.media;

  if (isLoading(mediaId) || isMediaLoading) {
    return <LoadingCreatorFragment />;
  }

  if (!media) {
    return null;
  }

  const mediaType = (media.mediaType ?? "NONE") as MediaTypes;

  const groupByMediaType: Record<string, MediasAndArticleCountResponse[]> = {
    [mediaType]: [
      {
        ...media,
        mediaId: media.id,
        mediaType: mediaType,
        nbrArticles: 0,
        parentArticleCombinationNumber: undefined,
        articleId: "",
        groupId: "",
        groupName: "",
        parentMediaName: "",
      },
    ],
  };

  return (
    <TitledTextWithModal
      title={title}
      description={media.name}
      modalContent={
        <MediaPlacementsListView
          groupedMediasByType={groupByMediaType}
          showCheckBox={false}
        />
      }
    />
  );
}

export default MediaLocationCreatorFragment;
